export const getReports = state => state.reportsContent;
export const getPaymentsReportData = state => state.reportsContent.paymentsReportData;
export const getPaymentsReportStatus = state => state.reportsContent.paymentsReportStatus;
export const paymentsReportLoading = state => state.reportsContent.isLoading;
